import axios from 'axios'
import { getCookie } from '@/utils/auth'
// import Toast from 'muse-ui-toast'

// Vue.use(Toast)
// 创建axios实例
let service = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? Vue.prototype.BASE_API : Vue.prototype.BASE_URL, // api 的 base_url
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (getCookie('accessToken')) {
      config.headers['Authorization'] = `Bearer ${getCookie('accessToken')}` // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非1是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.status !== 1) {
      // Toast.error(res.msg)
      console.log(res.msg)
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    // Toast.error(error.message)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js